/* unplugin-vue-components disabled */import { render } from "./VideoDetails.vue?vue&type=template&id=3bbfef52&scoped=true"
import script from "./VideoDetails.vue?vue&type=script&lang=js"
export * from "./VideoDetails.vue?vue&type=script&lang=js"

import "./VideoDetails.vue?vue&type=style&index=0&id=3bbfef52&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbfef52"]])

export default __exports__